import React from 'react'

export default function Label({ children }) {
  return (
    <label className="block text-md font-medium sm:mt-px sm:pt-2 mb-1">{children}</label>
  )
}
